import axios from 'axios';
import { isNull } from 'util';
import dt from '../../helpers/currentDateTime';
import cloneObject from '../../helpers/cloneObject';
import moment from '../../helpers/moment';

export default {
  namespaced: true,
  state: {
    // czy trwa wyszukiwanie
    isSearching: false,

    // parametry wyszukiwania
    params: {
      stationFromID: null,
      stationToID: null,
      date: dt.currentDateForInput(),
      time: dt.currentTimeForInput(),
      departure: true,
      trainCategories: [], // lista ID wybranych kategorii
    },

    // wyniki wyszukiwania
    results: null,
  },
  mutations: {
    setIsSearching(state, data) {
      state.isSearching = data;
    },
    setParams(state, data) {
      state.params = data;
    },
    updateStationFrom(state, fromID) {
      state.params.stationFromID = fromID;
    },
    updateStationTo(state, toID) {
      state.params.stationToID = toID;
    },
    updateTrainCategories(state, data) {
      state.params.trainCategories = data;
    },
    setResults(state, data) {
      state.results = data;
    },
    prependResults(state, data) {
      state.results.results = data.results.concat(state.results.results);
    },
    appendResults(state, data) {
      state.results.results = state.results.results.concat(data.results);
    },
  },
  actions: {
    searchTrains({ commit, state }) {
      commit('setIsSearching', true);
      commit('setResults', null);

      axios.post('/api/searchTrains', state.params)
        .then((response) => { commit('setResults', response.data); commit('setIsSearching', false); })
        .catch(error => console.log(error));
    },
    fetchMore({ commit, state }, later) {
      const params = cloneObject(state.params);
      const index = later ? state.results.results.length - 1 : 0;
      const obj = state.results.results[index];

      params.date = moment(obj.departureTime).clone().add(later ? 1 : -1, 'days').format('YYYY-MM-DD');
      params.time = '00:00';

      axios.post('/api/searchTrains', params)
        .then((response) => {
          if (later) {
            commit('appendResults', response.data);
          } else {
            commit('prependResults', response.data);
          }
        })
        .catch(error => console.log(error));
    },
  },
  getters: {
    searchResultsAvailable: state => !isNull(state.results),
  },
};
